import { reactive } from 'vue'
const onLoadedListeners: Record<string, any[]> = {}
let isLoaded = false
let isInserted = false
let proxy = reactive({})
export const useScript = (
  {
    src,
    defer,
    ...others
  }: { src: string; defer: boolean } & Record<string, string>,
  { use }: { use: () => any }
) => {
  if (!isInserted) {
    const scr = document.createElement('script')
    const head = document?.head || document.getElementsByTagName('head')[0]
    scr.src = src
    scr.async = false // optionally
    scr.crossOrigin = 'anonymous'
    scr.referrerPolicy = 'no-referrer'
    scr.defer = true
    Object.entries(others).forEach(([name, value]) => {
      scr.setAttribute(name, value)
    })

    scr.addEventListener('load', () => {
      let retries = 100 // 5000ms
      const intvl = setInterval(() => {
        retries -= 1
        // @ts-ignore
        proxy = window.OneTrust
        if (proxy && Object.keys(proxy).length) {
          onLoadedListeners[src]?.forEach(cback => cback(proxy))
          isLoaded = true
          clearInterval(intvl)
        }
        if (retries <= 0) {
          clearInterval(intvl)
        }
      }, 50)
    })
    head.insertBefore(scr, head.firstChild)
    isInserted = true
  }

  const onLoaded = cb => {
    if (!isLoaded) {
      onLoadedListeners[src] ?? []
      onLoadedListeners[src].push(cb)
    } else {
      cb(proxy)
    }
  }
  return {
    proxy,
    onLoaded,
  }
}
